<template>
  <div id="app">
    <Header />
    <HeaderPage />
    <Introduce />
    <FooterPage />
  </div>
</template>
<script>
// 设置rem 函数
function setRem() {
  let size = 75;
  let scale = window.screen.width / 1920;
  if(window.screen.width<=750) {
    size = 75;
    scale = window.screen.width / 750;
  }
  // 给根元素设置font-size
  document.documentElement.style.fontSize =
  size * Math.min(scale, 2) + "px";
}
import Header from './components/Header.vue'
import HeaderPage from './components/HeaderPage.vue'
import Introduce from './components/Introduce.vue'
import FooterPage from './components/FooterPage.vue'
export default {
  components: {
    Header,
    HeaderPage,
    Introduce,
    FooterPage
  },
  mounted() {
    setRem()
    window.addEventListener("resize", setRem());
  },
  beforeDestroy() {
    window.removeEventListener("resize", setRem());
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
#app{
  width: 100%;
}
</style>